import { __assign } from 'tslib';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function isExoticComponent(component) {
    return (typeof component === "object" &&
        typeof component.$$typeof === "symbol" &&
        ["react.memo", "react.forward_ref"].includes(component.$$typeof.description));
}
function isClassComponent(component) {
    return (typeof component === "function" &&
        (function () {
            var proto = Object.getPrototypeOf(component);
            return !!proto.prototype && !!proto.prototype.isReactComponent;
        })());
}
function isReactComponent(component) {
    return (isClassComponent(component) ||
        typeof component === "function" ||
        isExoticComponent(component));
}
function flexRender(target, props) {
    if (props === void 0) { props = {}; }
    if (isReactComponent(target)) {
        var Comp = target;
        return React.createElement(Comp, __assign({}, props));
    }
    return target;
}

export { flexRender, isClassComponent, isExoticComponent, isReactComponent };
//# sourceMappingURL=component.esm.js.map
